import React, { useEffect } from "react";
import { Helmet } from 'react-helmet';
import { useState } from "react";
import axios from "axios";
import { buildApiUrl } from "../utils/api";
function RequesterList() {
    const [totalRequester, settotalRequester] = useState(0);
    useEffect(() => {
        const fetchRequesterData = async () => {
            try {
                const finderRes = await axios.get(buildApiUrl("/api/getFinders"));
                settotalRequester(finderRes.data);
            }
            catch (error) {
                console.error('Error fetching data', error);
            }
        }
        fetchRequesterData();
    }, [])
    return (
        <>
            <Helmet>
                <title>3pl Requester | 3pl Site</title>
            </Helmet>
            <div className="requesterList">
                <h1>LIST OF 3PL REQUESTERS</h1>
                <div class="table-responsive">
                    <table class="table table-bordered table-striped table-hover">
                        <thead class="custom-thead">
                            <tr>
                                <th>S.no</th>
                                <th>Name</th>
                                <th>E-mail</th>
                                <th>Contact Number</th>
                                <th>Firm Name</th>
                                <th>Location</th>
                                <th>Firm Website</th>
                                <th>Sales Channel</th>
                                <th>Service Need</th>
                                <th>Fulfillment Regions</th>
                                <th>Storage Type</th>
                                <th>Temperature Need</th>
                                <th>Go-Live</th>
                                <th>Contact Method</th>
                                <th>Total SKU</th>
                                <th>Avg.Monthly Orders</th>
                                <th>Product Type</th>
                                <th>Additional Details</th>
                            </tr>
                        </thead>
                        <tbody>
                            {totalRequester.length > 0 ? (
                                totalRequester.map((requester, index) => (
                                    <tr key={requester._id}>
                                        <td>{index + 1}</td> {/* Serial number */}
                                        <td>{requester.name}</td> {/* Assuming `name` field */}
                                        <td>{requester.email}</td> {/* Assuming `email` field */}
                                        <td>{requester.contactNumber}</td> {/* Assuming `phone` field */}
                                        <td>{requester.firmName}</td> {/* Assuming `company` field */}
                                        <td>{requester.location}</td>
                                        <td>{requester.firmWebsite}</td>
                                        <td>{requester.salesChannel}</td>
                                        <td>{requester.serviceNeeds || "-"}</td>
                                        <td>{requester.fulfillmentRegions || "-"}</td>
                                        <td>{requester.storageType || "-"}</td>
                                        <td>{requester.temperatureRequirement || "-"}</td>
                                        <td>{requester.preferredGoLiveDate || "-"}</td>
                                        <td>{requester.preferredContactMethod || "-"}</td>
                                        <td>{requester.totalSku}</td>
                                        <td>{requester.avgMonthlyOrders}</td>
                                        <td>{requester.productType}</td>
                                        <td>{requester.summary}</td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="5" className="text-center">No requesters found</td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
            </div>
        </>
    )
}
export default RequesterList
